import { render } from "./BFormValidFeedback.vue?vue&type=template&id=074b1d81"
import script from "./BFormValidFeedback.vue?vue&type=script&lang=js"
export * from "./BFormValidFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__